<template>
  <v-autocomplete
    v-model="teamIds"
    v-model:search="searchInput"
    :items="teams"
    :loading="loading"
    label="Teams"
    item-title="name"
    item-value="id"
    class="app-select"
    multiple
    hide-details
    chips
    @update:model-value="searchInput = ''"
  >
    <template #chip="{ item }">
      <CommonChip closable @click:close="removeHandler(item.raw.id)">
        {{ item.raw.name }}
      </CommonChip>
    </template>
  </v-autocomplete>
</template>

<script lang="ts">
import { PropType, defineComponent } from 'vue';

import Team from '@/bundles/Teams/models/Team';
import { teamsService } from '@/bundles/Teams/factory/teamsFactory';
import { useNotifications } from '@/bundles/App/composables/useNotifications';

import CommonChip from '@/bundles/Common/components/chips/CommonChip.vue';

export default defineComponent({
  name: 'TeamsSelect',

  components: { CommonChip },

  props: {
    modelValue: {
      type: Array as PropType<number[]>,
      default: () => [],
    },
  },

  emits: ['update:modelValue'],

  setup () {
    const { addNotification } = useNotifications();

    return { addNotification };
  },

  data: (): { searchInput: string; teams: Team[]; loading: boolean } => ({
    searchInput: '',
    teams: [],
    loading: false,
  }),

  computed: {
    teamIds: {
      get (): number[] {
        return this.modelValue;
      },
      set (value: number[]) {
        this.$emit('update:modelValue', value);
      },
    },
  },

  async created () {
    try {
      this.loading = true;
      this.teams = await teamsService.myTeams();
    } catch (error) {
      this.addNotification({ ...error, status: 0 });
    } finally {
      this.loading = false;
    }
  },

  methods: {
    removeHandler (id: number) {
      this.$emit('update:modelValue', this.teamIds.filter((teamId) => teamId !== id));
    },
  },
});
</script>
